import { Button } from "./ui/button";

const prompts = [
  {
    text: "Optimize my complete resume",
    emoji: "✨",
    sessionType: "resume_optimization",
    badge: "Generates Resume",
  },
  {
    text: "Help me think through my resume strategy",
    emoji: "💭",
    sessionType: "resume_strategy",
    badge: "Coaching Session",
  },
  {
    text: "Analyze a job description",
    emoji: "🔍",
    sessionType: "job_analysis",
    badge: "Gap Analysis",
  },
  {
    text: "Build my LinkedIn profile",
    emoji: "💼",
    sessionType: "linkedin_builder",
    badge: "Generates Content",
  },
  {
    text: "Prepare for my interview",
    emoji: "🎯",
    sessionType: "interview_prep",
    badge: "Coaching Session",
  },
  {
    text: "Help me negotiate my salary",
    emoji: "💰",
    sessionType: "salary_negotiation",
    badge: "Coaching Session",
  },
  {
    text: "Plan my career path",
    emoji: "🚀",
    sessionType: "career_planning",
    badge: "Coaching Session",
  },
  {
    text: "Network effectively",
    emoji: "🤝",
    sessionType: "networking",
    badge: "Coaching Session",
  },
  {
    text: "Ask about market trends",
    emoji: "📊",
    sessionType: "general",
    badge: "Conversation",
  },
];

export const QuickStartPills = ({ onPillClick }) => {
  const colors = ["bg-primary", "bg-secondary", "bg-accent"];

  return (
    <div className="space-y-4 md:space-y-6 py-4 md:py-8">
      <div className="text-center space-y-2 md:space-y-3 px-3">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
          Welcome to Moil AI Career Coach
        </h2>
        <p className="text-muted-foreground text-sm md:text-base lg:text-lg">
          Choose a topic to get started, or type your own question
        </p>
      </div>

      <div className="flex flex-wrap gap-2 md:gap-3 justify-center max-w-3xl mx-auto px-2">
        {prompts.map((prompt, index) => (
          <div key={index} className="relative group">
            <Button
              onClick={() => onPillClick(prompt.text, prompt.sessionType)}
              className={`${
                colors[index % 3]
              } text-white rounded-full px-3 py-2 md:px-6 md:py-3 text-xs md:text-sm font-medium transition-all hover:scale-105 hover:shadow-lg`}
              variant="default"
            >
              <span className="mr-1 md:mr-2 text-sm md:text-base">{prompt.emoji}</span>
              <span className="truncate max-w-[150px] md:max-w-none">{prompt.text}</span>
            </Button>
            <div className="hidden md:block absolute -top-2 -right-2 bg-background border border-border rounded-full px-2 py-0.5 text-[10px] font-medium text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-sm">
              {prompt.badge}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
